export default {
  PHONE_MASK: '+7 (999) 999 99-99',
  PASSPORT_NUMBER_MASK: '9999 999999',
  DATE_MASK: '99.99.9999',
  DATETIME_MASK: '99.99.9999 99:99',
  POST_CODE_MASK: '999999',
  INN_NUMBER_MASK: '999999999999',
};
